import React from "react";

let listeners = new Set<(now: number) => void>();

setInterval(() => {
  listeners.forEach(l => l(Date.now()));
}, 1000);

export function subscribe(listener: (now: number) => void) {
  listeners.add(listener);
  return (): void => {    
    listeners.delete(listener)
  };
}

export function getSnapshot(): number {
  return Date.now();
}

export function useClock() {
  const [now, setNow] = React.useState(getSnapshot);

  React.useEffect(() => {    
    return subscribe((now) => setNow(now)); // wrapped for correct type
  }, []);

  return now;
}